export default function({ $auth }) {
  if (!$auth.loggedIn) {
    return
  }
  const user = $auth.user
  user.clientId = $auth.user.id
  $auth.setUser(user)
}
